const s = (i, o) => o ? i.some(
  (n) => n.rules.some((r) => r.id !== o.ruleId ? !1 : o.conditionId ? r.shippingConditions.some((e) => e.id === o.conditionId) : !0)
) : !1;
export {
  s as doesShippingServicesHaveShippingMethod
};
